export default function() {
    jQuery('.js-faq--question').on('click', function() {
        jQuery(this).parent().toggleClass('active');
        jQuery(this).next('.js-faq--answer').slideToggle(300);
    });
}